// constants.ts

export const NAME = 'newProject';